"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.light = void 0;
var _material = require("@mui/material");
var _IsidoraSansRegular = _interopRequireDefault(require("./fonts/IsidoraSans-Regular.ttf"));
var _IsidoraSansSemiBold = _interopRequireDefault(require("./fonts/IsidoraSans-SemiBold.ttf"));
var _IsidoraSansRegular2 = _interopRequireDefault(require("./fonts/IsidoraSans-Regular.eot"));
var _IsidoraSansSemiBold2 = _interopRequireDefault(require("./fonts/IsidoraSans-SemiBold.eot"));
var _IsidoraSansRegular3 = _interopRequireDefault(require("./fonts/IsidoraSans-Regular.eot?#iefix"));
var _IsidoraSansSemiBold3 = _interopRequireDefault(require("./fonts/IsidoraSans-SemiBold.eot?#iefix"));
var _IsidoraSansRegular4 = _interopRequireDefault(require("./fonts/IsidoraSans-Regular.svg#IsidoraSans-Medium"));
var _IsidoraSansSemiBold4 = _interopRequireDefault(require("./fonts/IsidoraSans-SemiBold.svg#IsidoraSans-SemiBold"));
var _IsidoraSansRegular5 = _interopRequireDefault(require("./fonts/IsidoraSans-Regular.woff"));
var _IsidoraSansSemiBold5 = _interopRequireDefault(require("./fonts/IsidoraSans-SemiBold.woff"));
var _IsidoraSansRegular6 = _interopRequireDefault(require("./fonts/IsidoraSans-Regular.woff2"));
var _IsidoraSansSemiBold6 = _interopRequireDefault(require("./fonts/IsidoraSans-SemiBold.woff2"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const light = exports.light = (0, _material.createTheme)({
  palette: {
    mode: 'light',
    primary: {
      "100": '#371E80',
      "200": '#A497CC',
      "300": '#7A6CA8',
      "400": '#695A9D',
      "500": '#4B358B',
      "600": '#371E80',
      main: '#371E80'
    },
    secondary: {
      "100": '#DDB0CD',
      "200": '#D9A6C8',
      "300": '#C684AF',
      "400": '#BF74A5',
      "500": '#B95496',
      "600": '#B03E89',
      main: '#B03E89'
    },
    error: {
      main: "#DC2121"
    },
    success: {
      main: "#40C402"
    },
    grey: {
      "50": "#FFFFFF",
      "100": "#F9F9F9",
      "200": "#EBE9E9",
      "300": '#F2F2F2',
      "400": '#EDEDED',
      "500": '#AEAEAE',
      "600": '#848484',
      "700": '#4F4F4F',
      "800": '#2D2D2D',
      "900": '#000000',
      main: "#848484"
    },
    background: {
      default: '#FFFFFF'
    },
    shape: {
      borderRadius: 8
    }
  },
  typography: {
    fontFamily: 'IsidoraSans',
    letterSpacing: "0.05em",
    h1: {
      fontWeight: 400,
      fontSize: 60
    },
    h2: {
      fontWeight: 400,
      fontSize: 48
    },
    h3: {
      fontWeight: 400,
      fontSize: 34
    },
    h4: {
      fontWeight: 400,
      fontSize: 24
    },
    h5: {
      fontWeight: 400,
      fontSize: 21
    },
    h6: {
      fontWeight: 400,
      fontSize: 18
    },
    body1: {
      fontWeight: 600,
      fontSize: 16
    },
    body2: {
      fontWeight: 400,
      fontSize: 16
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: 14
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: 14
    },
    button: {
      fontWeight: 600,
      fontSize: 18
    },
    caption: {
      fontWeight: 600,
      fontSize: 12
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: "\n        @font-face {\n          font-family: 'IsidoraSans';\n          font-style: normal;\n          font-display: swap;\n          font-weight: 400;\n          src: url('".concat(_IsidoraSansRegular2.default, "');\n          src: url('").concat(_IsidoraSansRegular3.default, "') format('embedded-opentype'),\n              url('").concat(_IsidoraSansRegular6.default, "') format('woff2'),\n              url('").concat(_IsidoraSansRegular5.default, "') format('woff'),\n              url('").concat(_IsidoraSansRegular.default, "') format('truetype'),\n              url('").concat(_IsidoraSansRegular4.default, "') format('svg');\n        },\n        @font-face {\n          font-family: 'IsidoraSans';\n          font-style: normal;\n          font-display: swap;\n          font-weight: 600;\n          src: url('").concat(_IsidoraSansSemiBold2.default, "');\n          src: url('").concat(_IsidoraSansSemiBold3.default, "') format('embedded-opentype'),\n              url('").concat(_IsidoraSansSemiBold6.default, "') format('woff2'),\n              url('").concat(_IsidoraSansSemiBold5.default, "') format('woff'),\n              url('").concat(_IsidoraSansSemiBold.default, "') format('truetype'),\n              url('").concat(_IsidoraSansSemiBold4.default, "') format('svg');\n        }\n      ")
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 15
        }
      }
    }
  }
});